interface MembershipCardProps {
  active?: boolean;
}

export default function Component({ active = true }: MembershipCardProps) {
  return (
    <div
      className="relative w-[361px] h-[212px] rounded-[10px] border border-[#404040] overflow-hidden"
      style={{
        background: "linear-gradient(236deg, #3F3F3F 0.91%, #090909 76.42%)",
      }}
    >
      {/* Wavy pattern background */}
      <div className="absolute inset-0 opacity-80">
        <img
          src="/assets/membership/looper.png"
          alt="Wavy Animation"
          className="w-full h-full"
        />
      </div>

      {/* Card content */}
      <div className="relative z-10 h-full flex flex-col justify-between p-6">
        <div>
          <div className="flex justify-between">
            {active && (
              <div className="flex flex-col">
                <div className="flex gap-1">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#4ADE80] mt-1" />
                  <span className="text-[#4ADE80] text-[10px] font-medium tracking-wide">
                    ACTIVE
                  </span>
                </div>
                <div className="space-y-1">
                  <h2 className="text-[28px] font-bold leading-tight text-white">
                    1% Club
                  </h2>
                </div>
              </div>
            )}
            <div className="text-right">
              <p className="text-[#CDCDCD] text-lg font-bold bg-gradient-text text-transparent bg-clip-text">
                Lifetime
              </p>
              <p className="text-[#CDCDCD] text-lg font-bold bg-gradient-text text-transparent bg-clip-text">
                Access
              </p>
            </div>
          </div>

          <div className="flex justify-between items-start"></div>
        </div>
      </div>
    </div>
  );
}
